"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transposeForOption = void 0;
var Result_1 = require("../PlainResult/Result");
var Option_1 = require("./Option");
/**
 *  Transposes an `Option` of a `Result` into a `Result` of an `Option`.
 *
 *  - `Some(Ok(x))` -> `Ok(Some(x))`
 *  - `Some(Err(e))` -> `Err(e)`
 *  - `None` => `Ok(None)`
 */
function transposeForOption(input) {
    if ((0, Option_1.isNone)(input)) {
        var inner_1 = (0, Option_1.createNone)();
        var result_1 = (0, Result_1.createOk)(inner_1);
        return result_1;
    }
    var inner = input.val;
    if ((0, Result_1.isErr)(inner)) {
        var e = inner.err;
        var result_2 = (0, Result_1.createErr)(e);
        return result_2;
    }
    var innerInner = inner.val;
    var some = (0, Option_1.createSome)(innerInner);
    var result = (0, Result_1.createOk)(some);
    return result;
}
exports.transposeForOption = transposeForOption;
